import * as math from './math';
/**
 * Converts temperature from Fahrenheit to Celsius
 * @param fahrenheit - Temperature in Fahrenheit
 * @returns Temperature in Celsius
 */
export const fahrenheitToCelsius = (fahrenheit: number): number => {
  return Number(((fahrenheit - 32) * (5 / 9)).toFixed(2));
};

/**
 * Converts temperature from Celsius to Fahrenheit
 * @param celsius - Temperature in Celsius
 * @returns Temperature in Fahrenheit
 */
export const celsiusToFahrenheit = (celsius: number): number => {
  return math.round((celsius * 9) / 5 + 32, 2);
};
